<mat-card>
  <mat-card-content>
    <mat-card-title>Contas a Pagar x Receber</mat-card-title>

    <div class="chart-container">

      <div class="chart-wrapper" *ngIf="incomesAndExpenses.length > 0">
        <ngx-charts-bar-vertical-2d
          [view]="view"
          [scheme]="colorScheme"
          [results]="chartData"
          [gradient]="gradient"
          [xAxis]="showXAxis"
          [yAxis]="showYAxis"
          [legend]="showLegend"
          [legendPosition]="legendPosition"
          [showXAxisLabel]="showXAxisLabel"
          [showYAxisLabel]="showYAxisLabel"
          [yAxisTickFormatting]="yAxisTickFormatting"
          [barPadding]="200"
          [groupPadding]="16">

          <ng-template #tooltipTemplate let-model="model">
            <div style="padding: 5px;">
              <span style="display: block; font-size: 12px; color: #cfcfcf;">{{ model.name }}</span>
              <span style="display: block; font-size: 14px; font-weight: bold; color: #ffffff;">{{ model.value | currency: 'BRL' }}</span>
            </div>
          </ng-template>

        </ngx-charts-bar-vertical-2d>
      </div>

      <div *ngIf="incomesAndExpenses.length === 0" class="no-data-overlay">
        <mat-icon>bar_chart</mat-icon>
        <p>Não há dados de contas a pagar x receber</p>
      </div>

    </div>
  </mat-card-content>
</mat-card>
